<template>
    <div class="p-relative">
        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>
        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
        >
        </FilterPanel>

        <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents|CitizenStatements.Document', common: data.item.iscommon })">
                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.regnumber`]="{ item }">
                    <td class="clt-col-wrap text-start">
                        <span class="clt-col-marker" :style="getStyle(item)"></span>{{ item.regnumber }}
                    </td>
                </template>

                <template v-slot:[`item.regdate`]="{ item }">
                    {{ formatDate(item.regdate) }}
                </template>

                <template v-slot:[`item.correspondent`]="{ item }">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.correspondent">
                            {{item.correspondent}}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.theme`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <v-doc-type-chip v-if="item.issubstitution" :type="'Substitution'" :text="$t('Замещение')"/>
                        <v-common-chip v-if="$helpers.getCommonStatusForList(item)" :document-type="item.doctypeof"/>
                        <v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.theme">
                                {{item.theme}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.controldate`]="{ item }">
                    {{ formatDate(item.controldate) }}
                </template>

                <template v-slot:[`item.svodname`]="{ item }">
                    <v-workplace-chip 
                    v-if="item.svodname"
                    :id="item.svodworkplaceid"
                    :name="item.svodname"
                />
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        <!--<ReportPeriodDlg ref="ReportPeriodDlgRef" />-->
    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import _ from 'lodash';
import sys from '@/services/system';
import { mapActions, mapGetters } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue'; 
import FilterPanel from '@/components/documents/FilterPanel.vue';
//import ReportPeriodDlg from '@/components/global/dialogs/ReportPeriodDlg';

export default {
    name: "OrdersSvetofor",
    components: {
        Toolbar,
        SearchPanel,
        FilterPanel,
        //ReportPeriodDlg
    },
    computed:{
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        headers() {
            return [
                { text: this.$t("Номер"), value: 'regnumber', width: '150px'  },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px'  },
                { text: this.$t("Корреспондент"), value: 'correspondent', width: '20%' },
                { text: this.$t("Краткое_содержание"), value: 'theme' },
                { text: this.$t("Срок"), value: 'controldate', width: '110px'  },
                { text: this.$t("Исполнитель"), value: 'svodname', width: '150px'  },
            ];
        },
        search: {
            get: function() {
                return this.$store.getters[`correspondence/svetofor/getSearch`];
            },
            set: _.debounce(function(v) {
                this.$store.commit(`correspondence/svetofor/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`correspondence/svetofor/SET_SEARCH`, v);
            }, 500)
        },
        status: {
            get: function() {
                return this.$store.getters[`correspondence/svetofor/getStatus`];
            },
            set: function(v) {
                if (v){
                    this.$store.commit(`correspondence/svetofor/SET_TABLE_OPTION_PAGE`, 1);
                    this.$store.commit(`correspondence/svetofor/SET_STATUS`, v);
                }
            }
        },
        options: {
            get: function() {
                return this.$store.getters[`correspondence/svetofor/getTableOptions`];
            },
            set: function(newValue) {
                this.$store.commit(`correspondence/svetofor/SET_TABLE_OPTION`, newValue);
            }
        },
    },
    data: () => {
        return {
            loading: true,
            total: 0,            
            entities: [],
            paginationPageCount: 0,
            filterDataSource: {
                Filter: {
                    Title: 'Срок_исполнения',
                    Default: 'All',
                    Items: [
                        { Name: "Любой", Value: "All", Count: -1 },
                        { Name: "Более_10_дней", Value: "MoreThan10Days", Count: -1 },
                        { Name: "Менее_10_дней", Value: "LessThan10Days", Count: -1 },
                        { Name: "Сегодня", Value: "Today", Count: -1 },
                        { Name: "Просрочено", Value: "Expired", Count: -1 }
                    ]
                }
            },
            columnIndex: {}
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        resetPage() {
            this.$store.commit('correspondence/completed/SET_TABLE_OPTION_PAGE', 1);
        },
        onToolbarClick(event, btn){
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        /*async Export(){
            let filter = JSON.parse(this.getTableFilterObject());
            delete filter.Limit;
            delete filter.Offset;
            filter.Export = true;
            let exportURI = `/api/correspondence/list?collection=Svetofor&filter=${JSON.stringify(filter)}&mode=${process.env.NODE_ENV}`;
            exportURI += `&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
            
            let text = i18n.t('Экспорт_списка_поручений');

            this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'Xls' });
        },*/
        formatDate(value) {
            if (!value)
                return '';

            return this.$moment(value).format('DD.MM.YYYY');
        },
        getStyle(item){
            if (!item.execdate || this.$moment(item.execdate).isAfter(this.$moment(item.controldate)))
                return { background: sys.getExecutionColorStatus(item.controldate)};
            return null;
        },
        async getData() {
            this.setOverlayVisible({ visible: true });    
            this.total = 0;
            this.entities = [];
            this.loading = true;
            try {
                let response = await httpAPI({
                    url: `/api/correspondence/list?collection=Svetofor&filter=${this.getTableFilterObject()}`,
                    method: 'GET'
                });

                this.entities = response?.data?.Payload?.data ?? [];
                this.total = response?.data?.Payload?.total ?? 0;
                if (this.total > 0){
                    this.columnIndex = {};
                    Object.keys(this.entities[0]).forEach((key, index) => {
                        this.columnIndex[key] = index + 1; 
                    });
                }
                this.loading = false;
                this.setOverlayVisible({ visible: false });
                this.getCounter();
            }
            catch {
                console.error('Error loading data');
            } finally {
                this.loading = false;
                this.setOverlayVisible({ visible: false });
            }
        },
        getTableFilterObject() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            const sortColumn = sortBy[0] ?? "regdate";
            const OrderDir = sortDesc[0] ?? false;
            const OrderBy = this.columnIndex?.[sortColumn] ?? 4;
            return JSON.stringify({ ControlState: '1', ExecutionStatus: this.status, SearchStr: this.search, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        async getCounter(){
            this.$eventBus.$emit('update_correspondents_counters');
            try {
                let response = await httpAPI({
                    url: `/api/correspondence/svetofor/counter`,
                    method: 'GET'
                });
                if (response?.data?.Payload){
                    const counters = response.data.Payload;
                    this.filterDataSource.Filter.Items.forEach(item => {
                        switch (item.Value){
                            case "All": item.Count = counters.total; break;
                            case "MoreThan10Days": item.Count = counters.morethan10days; break;
                            case "LessThan10Days": item.Count = counters.lessthan10days; break;
                            case "Today": item.Count = counters.today; break;
                            case "Expired": item.Count = counters.expired; break;
                        }
                    });
                }
            }
            catch {
                console.error('Error loading counters');
            }
        }
    },
    watch: {
        search: 'getData',
        status: 'getData',
        options: {
            handler: 'getData',
            deep: true
        }
    },
    async created() {
        let menu = [
            /*{
                "Action": "Export",
                "Icon": "doc_send",
                "Items": null,
                "Text": "Экспорт_списка",
                "ToolTip": "Экспорт_полного_списка_поручений",
                "Type": "Documents",
                Localize: true
            },*/
            {
                "Action": "Refresh",
                "Icon": "refresh",
                "Items": null,
                "Text": "Обновить",
                "ToolTip": "Обновить_форму",
                "Type": null,
                Localize: true
            }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu });
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    },
}
</script>
